import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { BreadcrumbService } from 'src/app/core/framework/breadcrumb.service';
import { Status } from 'src/app/core/framework/default.model';
import { ToasterService } from 'src/app/core/framework/toaster/toaster.service';
import { PermissaoNome } from 'src/app/seguranca/perfil-de-acesso/permissao/permissao-nome.enum';
import { UsuarioService } from 'src/app/seguranca/usuario/usuario/usuario.service';
import { environment } from 'src/environments/environment';
import { ReleaseNoteFilter } from '../../model/release-note.filter';
import { ReleaseNote } from '../../model/release-note.model';
import { ReleaseNoteService } from '../../release-note.service';


@Component({
  selector: 'app-release-note-home',
  templateUrl: './release-note-home.component.html',
  styleUrls: ['./release-note-home.component.css']
})
export class ReleaseNoteHomeComponent implements OnInit {

  static releaseNoteHomeUri = '/seguranca/configuracao/release-note-home';

  releaseNotes: ReleaseNote[] = [];
  releaseNoteSelecionado: ReleaseNote = null;


  constructor(
    private breadcrumbService: BreadcrumbService,
    private releaseNoteService: ReleaseNoteService,
    private toasterService: ToasterService,
    private router: Router,
    private usuarioService: UsuarioService
  ) { }

  ngOnInit(): void {
    const temPermissaoPraVerRelease = this.usuarioService.usuarioLogadoTemPermissao(PermissaoNome.ROLE_PESQUISAR_RELEASE_NOTE);
    if ( !temPermissaoPraVerRelease ) {
      this.toasterService.info('O seu usuário não possui permissão para visualizar release notes.');
      
      this.router.navigate([environment.caminho_pagina_inicial]);
    }

    if ( this.releaseNotes.length > 0 ) {
      this.releaseNoteSelecionado = this.releaseNotes[0];
    }
    else {
      this.carregarReleaseNotes();
    }

    setTimeout(() => {
      this.atualizarBreadcrumb();
    }, 500);
  }
  
  atualizarBreadcrumb(): void {
    this.breadcrumbService.setItems([{label: 'Segurança'}, {label: 'Configuração'}, {label: 'Release notes'}]);
  
    this.breadcrumbService.setMenuConfig(
      this.breadcrumbService.getOrCreateMenuConfig()
          .hideAll()
          .setShowVoltar(true)
    );    

  }

  carregarReleaseNotes(): void {
    const toasterId = this.toasterService.wait();
      
    const filter: ReleaseNoteFilter = {
      status: Status.ATIVO,
      publicado: true,
      sort: ['data,desc']
    }

    const filterNaoLidas: ReleaseNoteFilter = {
      status: Status.ATIVO,
      publicado: true,
      idUsuarioLeitor: UsuarioService.getUsuarioFromLocalStorage().id,
      sort: ['data,desc']
    }

    zip(
      this.releaseNoteService.listar(filter)
      , this.releaseNoteService.listar(filterNaoLidas)
    )
    .pipe(
      map(result => {
        const todosOsReleaseNotes  : ReleaseNote[] = result[0].content;
        const releaseNotesNaoLidos : ReleaseNote[] = result[1].content;

        todosOsReleaseNotes.forEach(item => {
          releaseNotesNaoLidos.forEach(itemNaoLido => {
            if ( item.id === itemNaoLido.id ) {
              item.naoLido = true;
            }
          })
        });

        return todosOsReleaseNotes;
      })
    )
    .subscribe((todosOsReleaseNotes  : ReleaseNote[]) => {
      this.releaseNotes = todosOsReleaseNotes;
      if ( this.releaseNotes.length === 0 ) {
        this.toasterService.info('Nenhuma release note encontrada.');
        this.router.navigate([environment.caminho_pagina_inicial]);
      }
      else {
        this.releaseNoteSelecionado = this.releaseNotes[0];
      }

      this.toasterService.clearWait(toasterId);
    });
  }

  abrirReleaseNoteEventEmitter(releaseNote: ReleaseNote): void {
    this.releaseNoteSelecionado = releaseNote;
  }

}
